import React from "react";
import { Link } from "react-router-dom";
import { Zap, Rocket } from "lucide-react";

export default function FloatingActions() {
  return (
    <div className="fixed right-0 top-1/2 -translate-y-1/2 z-[60] flex flex-col gap-3 pr-4 hidden md:flex">
      {/* AI Pick My Plan Button */}
      <Link
        to="/plan-recommender"
        className="group relative flex items-center justify-center w-12 h-12 rounded-full transition-all duration-300 hover:w-48 hover:justify-start hover:px-4 no-underline"
        style={{
          background: "rgba(10,10,18,0.9)",
          border: "1px solid #00F3FF",
          boxShadow: "0 0 15px rgba(0, 243, 255, 0.3)",
        }}
      >
        <Zap size={20} color="#00F3FF" className="min-w-[20px]" />
        <span className="ml-3 font-rajdhani font-700 text-[#00F3FF] text-xs whitespace-nowrap opacity-0 max-w-0 group-hover:opacity-100 group-hover:max-w-[150px] transition-all duration-300 overflow-hidden">
          AI PICK MY PLAN
        </span>
      </Link>

      {/* Get Started Button */}
      <Link
        to="/vps-hosting"
        className="group relative flex items-center justify-center w-12 h-12 rounded-full transition-all duration-300 hover:w-48 hover:justify-start hover:px-4 no-underline"
        style={{
          background: "rgba(10,10,18,0.9)",
          border: "1px solid #BC13FE",
          boxShadow: "0 0 15px rgba(188, 19, 254, 0.3)",
        }}
      >
        <Rocket size={20} color="#BC13FE" className="min-w-[20px]" />
        <span className="ml-3 font-rajdhani font-700 text-[#BC13FE] text-xs whitespace-nowrap opacity-0 max-w-0 group-hover:opacity-100 group-hover:max-w-[150px] transition-all duration-300 overflow-hidden">
          GET STARTED
        </span>
      </Link>
    </div>
  );
}
